export default function TrustSection() {
  const stats = [
    { value: '14', label: 'Categories' },
    { value: '10K+', label: 'Products' },
    { value: '60+', label: 'Guides' },
    { value: 'Daily', label: 'Updates' },
  ];

  const features = [
    {
      icon: 'ri-time-line',
      title: 'Save Time',
      desc: 'Find products faster without endless searching through multiple platforms.',
    },
    {
      icon: 'ri-stack-line',
      title: 'Better Organization',
      desc: 'Browse thousands of products by category with our structured spreadsheet system.',
    },
    {
      icon: 'ri-scales-line',
      title: 'Smart Comparison',
      desc: 'Compare products, prices and popularity across different categories easily.',
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Updated Finds',
      desc: 'Discover trending products regularly with our continuously updated database.',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-primary-50/50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-14 md:mb-16">
          <span className="inline-block bg-background-50 text-primary-600 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            Live Database
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-extrabold text-foreground-950 leading-[1.15]">
            Discover. Compare.
          </h2>
          <p className="font-heading text-2xl md:text-4xl font-bold text-primary-400 mt-1">
            Buy Smarter.
          </p>
        </div>

        {/* Feature Descriptions */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8 mb-14 md:mb-16">
          {['Updated Daily', 'Western Aesthetic', 'Product Images', 'SEO Ready'].map((f) => (
            <div key={f} className="text-center">
              <p className="text-sm md:text-base font-semibold text-foreground-800">{f}</p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-4xl md:text-6xl font-extrabold text-primary-500 mb-2">
                {stat.value}
              </p>
              <p className="text-xs md:text-sm font-medium text-foreground-600 uppercase tracking-wide">
                {stat.label}
              </p>
            </div>
          ))}
        </div>

        {/* What is Kakobuy Spreadsheet - SEO Content */}
        <div className="mt-16 md:mt-20 bg-background-50 rounded-2xl p-8 md:p-12 max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
            What Is Kakobuy Spreadsheet?
          </h2>
          <div className="space-y-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            <p>
              A <strong>kakobuy spreadsheet</strong> is a meticulously organized database that compiles thousands of product finds across multiple categories — from sneakers and hoodies to accessories and tech gadgets. Unlike browsing individual store pages, a well-structured <strong>kakobuy spreadsheet list</strong> gives you instant access to trending items, price comparisons, and detailed product information all in one convenient place.
            </p>
            <p>
              The <strong>best kakobuy spreadsheet</strong> resources are updated regularly to reflect the latest trends, making them invaluable tools for savvy shoppers who want to discover products efficiently. Whether you are hunting for the newest sneaker drops, comparing jacket prices, or exploring luxury accessories, our <strong>kakobuy finds</strong> database covers every category with detailed organization and easy navigation. Each entry is carefully curated to help you make informed decisions without the hassle of manual searching.
            </p>
            <p>
              Our platform serves as an independent hub connecting you to the most comprehensive spreadsheet resources. We organize thousands of products across 14 specialized categories, ensuring that every shopper — from beginners to experienced deal hunters — can find exactly what they need through an intuitive and visually clean interface.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}